<template>
	<div class="filter-newsroom-event__filter">
		<span class="filter-newsroom-event__title">{{eventFilterlngtxt.title}}</span>
		<div class="filter-newsroom-event__zone is-hideFilter" data-js-id="fl_2" data-js-filtertyp="period" :data-js-lng="getLngShort" data-js-item="js-filter-newsroom-event-zone">
			<button class="filter-newsroom-event__zone-title" data-js-item="js-filter-newsroom-event-select" aria-haspopup="true" aria-expanded="false" type="button">
				<span class="filter-newsroom-event__zone-title-text">{{eventFilterlngtxt.choose_txt}}</span>
			</button>
			<div class="filter-newsroom-event__zonecontent" :role="eventFilterlngtxt.dropdown_txt">
				<div class="filter-newsroom-event__zonecontent-scroll" data-js-item="js-filter-newsroom-event-zonecontent-scroll">
					<FilterNewsroomEventButtonItem v-for="(item, index) in eventFilterTimeItemsButton" :key="index" :item="item"/>
					<div class="filter-newsroom-event__formfields">
						<fieldset class="form__fieldset filter-newsroom-event__date">
							<div class="form__row filter-newsroom-event__datearea">
								<div class="form__col">
									<div class="form__datepicker" data-js-module="form-datepicker" :data-js-lng="getLngShort" data-js-item="js-form-datepicker-area">
										<div class="form__datepicker-inputarea" v-if="eventFilterTimeItemsInput">
											<FilterNewsroomEventInputItem v-for="(item, index) in eventFilterTimeItemsInput" :key="index" :item="item"/>
										</div>
										<div class="form__datepicker-container" data-js-item="js-form-datepicker-container"></div>
										<div class="form__datepicker-container" data-js-item="js-form-datepicker-container"></div>
									</div>
								</div>
							</div>
						</fieldset>
					</div>
					<div class="filter-newsroom-event__errortext is-hideFilter" data-js-item="js-filter-newsroom-event-errortext">
						{{eventFilterlngtxt.errordate_txt}}
					</div>
				</div>
				<div class="filter-newsroom-event__buttonarea">
					<button type="button" class="filter-newsroom-event__submitbutton" data-js-id="fl_b_2" data-js-item="js-filter-newsroom-event-submitButton">
						{{eventFilterlngtxt.button_txt}}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import FilterNewsroomEventButtonItem from "./FilterNewsroomEventButtonItem.vue";
import FilterNewsroomEventInputItem from "./FilterNewsroomEventInputItem.vue";
export default {
  	name: "FilterNewsroomEventTime",
  	components: {
		  FilterNewsroomEventButtonItem,
		  FilterNewsroomEventInputItem
  	},
  	computed: {
		eventFilterTimeItemsButton() {
      		return this.$store.getters.eventfilteritems.timeitems.buttons;
		},
		eventFilterTimeItemsInput() {
      		return this.$store.getters.eventfilteritems.timeitems.inputs;
		},
		eventFilterlngtxt() {
      		return this.$store.getters.lngtxt.eventfilter.eventfiltertime;
		},
		getLngShort() {
      		return this.$store.getters.lngshort;
		}
  	}
};
</script>
